import { HStack, useCheckboxGroup } from '@chakra-ui/react';

import {
  Box,
  VARIANTS,
  Badge,
  Typography,
  ButtonGroup,
  Button,
  Divider,
  ButtonIcon,
  MenuRoot,
  MenuItemGroup,
  MenuCheckboxItem,
  MenuContent,
  MenuTrigger,
  Show,
} from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer';
import { capitalize } from 'shared_DEPRECATED/utils';

import {
  DESELECT_ALL_GOALS_LABEL,
  SELECT_ALL_GOALS_LABEL,
  UNLINKED_CHALLENGES_CONFIG,
  UNLINKED_CHALLENGES_VALUE,
  useSelectedGoalsContext,
} from 'features/planning';

export const PlanningBoardGoalsFilter = () => {
  const {
    goals,
    selectedGoalsIds,
    selectAllGoals,
    deselectAllGoals,
    updateSelectedGoals,
    isLoading,
  } = useSelectedGoalsContext();

  const group = useCheckboxGroup({
    value: selectedGoalsIds,
    onValueChange: (selectedOptions: string[]) =>
      updateSelectedGoals(selectedOptions),
  });

  const isGoalsSelected =
    selectedGoalsIds.length === [...goals, UNLINKED_CHALLENGES_VALUE].length;

  const isNoGoalsSelected = !selectedGoalsIds.length;

  if (isLoading) {
    return null;
  }

  const items = goals.map(({ goalId, title, prioritized }) => ({
    title,
    value: goalId,
    prioritized,
  }));

  return (
    <MenuRoot closeOnSelect={false}>
      <MenuTrigger asChild>
        <ButtonIcon aria-label="Filter" variant="ghost" position="relative">
          <Icon name={iconNames.controls} height="14px" width="14px" />
          <Box
            style={{
              zIndex: 2,
              position: 'absolute',
              bottom: '55%',
              left: '55%',
            }}
          >
            {!!selectedGoalsIds.length && (
              <Badge colorPalette="blue" size="xs">
                <Typography color="whiteTotal" type="small">
                  {selectedGoalsIds.length}
                </Typography>
              </Badge>
            )}
          </Box>
        </ButtonIcon>
      </MenuTrigger>
      <MenuContent overflowX="hidden">
        <Spacer size="md lg">
          <ButtonGroup gap="0.5rem" size="xs">
            <Button
              borderRadius="var(--border-radius12)"
              onClick={selectAllGoals}
              color={VARIANTS.PRIMARY}
              disabled={isGoalsSelected}
            >
              {SELECT_ALL_GOALS_LABEL}
            </Button>
            <Button
              borderRadius="var(--border-radius12)"
              onClick={deselectAllGoals}
              color={VARIANTS.PRIMARY}
              disabled={isNoGoalsSelected}
            >
              {DESELECT_ALL_GOALS_LABEL}
            </Button>
          </ButtonGroup>
        </Spacer>
        <Divider orientation="horizontal" />
        <Box style={{ maxHeight: '15rem', width: '100%', overflowY: 'auto' }}>
          <MenuItemGroup>
            <MenuCheckboxItem
              checked={group.isChecked(UNLINKED_CHALLENGES_CONFIG.value)}
              onCheckedChange={() =>
                group.toggleValue(UNLINKED_CHALLENGES_CONFIG.value)
              }
              value={UNLINKED_CHALLENGES_CONFIG.value}
            >
              {UNLINKED_CHALLENGES_CONFIG.label}
            </MenuCheckboxItem>
            {items.map(({ title, value, prioritized }) => (
              <MenuCheckboxItem
                key={value}
                value={value}
                checked={group.isChecked(value)}
                onCheckedChange={() => group.toggleValue(value)}
              >
                <HStack justifyContent="space-between">
                  <Typography w="200px" cropped title={capitalize(title)}>
                    {capitalize(title)}
                  </Typography>
                  <Show when={prioritized}>
                    <Icon
                      name={iconNames.flagNew}
                      fill="var(--fgInteractive)"
                      stroke="var(--fgInteractive)"
                    />
                  </Show>
                </HStack>
              </MenuCheckboxItem>
            ))}
          </MenuItemGroup>
        </Box>
      </MenuContent>
    </MenuRoot>
  );
};
